import { Box, Grid } from "@mui/material";

type Props = {
    title: string;
    subTitle: string;
  };

export const TextCard = ({title, subTitle} : Props) => {
    return (
        <Grid
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
        >
            <Grid item xs={12}>
                <Box sx={{fontSize: 14, color: '#161728', fontWeight: '700'}}>{title}</Box>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{fontSize: 14, color: '#5C5D68', fontWeight: '500'}}>{subTitle}</Box>
            </Grid>
        </Grid>
    )
}